import { Mic, MicOff } from "lucide-react";

const VoiceToggle = ({ t, voiceOn, onToggle }) => (
  <button
    data-testid="voice-toggle"
    onClick={onToggle}
    aria-label={voiceOn ? t.voiceOff : t.voiceOn}
    aria-pressed={voiceOn}
    className={`flex h-10 w-10 items-center justify-center rounded-full border backdrop-blur-xl transition-[background-color,border-color,color] duration-300 ${
      voiceOn
        ? "border-amber-500/50 bg-amber-500/15 text-amber-300"
        : "border-white/10 bg-black/40 text-white/60 hover:text-white/90"
    }`}
  >
    {voiceOn ? <Mic className="h-4 w-4" strokeWidth={1.5} /> : <MicOff className="h-4 w-4" strokeWidth={1.5} />}
  </button>
);

export default VoiceToggle;
